// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H9eT","badges":"styles_badges__JJ-xS"};